import gql from 'graphql-tag'

export const ADD_FEEDBACK = gql`
  mutation addFeedback($conteudoId: String!, $nota: Int!, $comentario: String!) {
    addFeedback(conteudoId: $conteudoId, nota: $nota, comentario: $comentario)
  }
`
